module.exports = __webpack_public_path__ + "img/icon.d09fcc8a.png";